import { contentUrl } from '../api'

const url = `${contentUrl}/digital`

export const DIGITAL = {
  name: 'DIGITAL',
  title: 'DIGITAL',
  mobileType: "mobile",
  content: [
    {
      menuTemplate: 'SINGLE',
      menuName: 'Option 1',
      content: {
        contentTemplate: 'IMAGE',
        content: {
          imageList: [{ src: `${url}/option-1.png`, alt: "Option 1 - Digital" }],
          mobileImageList: [{ srcMobile: `${url}/option-1.png`, alt: "Option 1 - Digital" }],
        },
      }
    },
    {
      menuTemplate: 'SINGLE',
      menuName: 'Option 2',
      content: {
        contentTemplate: 'IMAGE',
        content: {
          imageList: [{ src: `${url}/option-2.png`, alt: "Option 2 - Digital" }],
          mobileImageList: [{ srcMobile: `${url}/option-2.png`, alt: "Option 2 - Digital" }],
        },
      }
    },
    {
      menuTemplate: 'SINGLE',
      menuName: 'Option 3',
      content: {
        contentTemplate: 'IMAGE',
        content: {
          imageList: [{ src: `${url}/option-3.png`, alt: "Option 3 - Digital" }],
          mobileImageList: [{ srcMobile: `${url}/option-3.png`, alt: "Option 3 - Digital" }],
        },
      }
    },
  ],
}
